import React, {useEffect} from 'react'

import {Button, Col, Input, Modal, Row, Table} from "antd";
import api from "../../api";
import {printPrice} from "../../helpers";
import {DATE_FORMAT, DEFAULT_GUTTER} from "../../constants";
import dayjs from "dayjs";
import OfferForm from "../../Components/OfferForm";
import CdnImage from "../../Components/CdnImage";
import {useAuth} from "../../auth";
import {useNavigate} from "react-router-dom";

export default function Offers() {
    const [offers, setOffers] = React.useState([]);
    const [offerFormModalOpen, setOfferFormModalOpen] = React.useState(false);
    const [editingOffer, setEditingOffer] = React.useState(null);
    const [filterText, setFilterText] = React.useState('');
    const {company} = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        api.getOffers().then(setOffers)
    }, []);

    // Filter offers based on search text
    const filteredOffers = offers.filter(offer => {
        if (!filterText) return true;
        const searchText = filterText.toLowerCase();
        return (
            (offer.title && offer.title.toLowerCase().includes(searchText)) ||
            (offer.description && offer.description.toLowerCase().includes(searchText))
        );
    });

    return (
        <div>
            <Row gutter={DEFAULT_GUTTER}>
                <Col md={12} xs={24}>
                    <h1>Mijn aanbod</h1>
                </Col>
                <Col md={12} xs={24} className={"text-right"}>
                    <Button className={"mar-r-1"} onClick={() => {
                        navigate('/store')
                    }}>Instellingen</Button>
                    <Button className={"mar-r-1"} href={`/${company.slug}`} target={"_blank"}>Profiel bekijken</Button>
                    <Button className={"mar-r-1"} onClick={() => {
                        window.open('/offers/print', '_blank')
                    }}>Bestellijst printen</Button>
                    <Button type={"primary"} onClick={() => setOfferFormModalOpen(true)}>Aanbod toevoegen</Button>

                </Col>
            </Row>

            {/* Search Filter */}
            <Row gutter={DEFAULT_GUTTER} className={"mar-b-1 mar-t-1"}>
                <Col span={24}>
                    <Input.Search
                        placeholder="Zoek in aanbod..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                        allowClear
                        style={{ maxWidth: 400 }}
                    />
                </Col>
            </Row>

            <Modal open={offerFormModalOpen} footer={null}
                   onCancel={() => {
                       setOfferFormModalOpen(false);
                       setEditingOffer(null);
                   }}>
                <OfferForm
                    offer={editingOffer}
                    onOffersChanged={() => {
                        api.getOffers().then(setOffers);
                        setOfferFormModalOpen(false);
                        setEditingOffer(null);
                    }}/>
            </Modal>

            <Table dataSource={filteredOffers} columns={[
                {
                    title: 'Aanbod', 
                    key: 'mobile', 
                    responsive: ['xs'], 
                    render(item) {
                        return (
                            <Row gutter={[16, 8]}>
                                <Col span={8}>
                                    <CdnImage
                                        src={item.image}
                                        width={80}
                                        height={80}
                                        alt={item.title}
                                    />
                                </Col>
                                <Col span={16}>
                                    <div>
                                        <h4 style={{ margin: '0 0 8px 0' }}>{item.title}</h4>
                                        <div><strong>Prijs:</strong> {printPrice(item.price)}{item.unit ? ` per ${item.unit}` : ''}</div>
                                        <div><strong>Voorraad:</strong> {item.stock}</div>
                                        {item.start_at && (
                                            <div><strong>Start:</strong> {dayjs(item.start_at).format(DATE_FORMAT)}</div>
                                        )}
                                        {item.end_at && (
                                            <div><strong>Einde:</strong> {dayjs(item.end_at).format(DATE_FORMAT)}</div>
                                        )}
                                        <div style={{ marginTop: '8px' }}>
                                            <Button
                                                size="small"
                                                onClick={() => {
                                                    setOfferFormModalOpen(true)
                                                    setEditingOffer(item)
                                                }}
                                                className={"mar-r-1"}
                                            >
                                                Aanpassen
                                            </Button>
                                            <Button danger
                                                size="small"
                                                onClick={() => {
                                                    Modal.confirm({
                                                        title: 'Aanbod archiveren?',
                                                        content: 'Dit aanbod wordt gearchiveerd en niet meer getoond op je profiel.',
                                                        okText: 'Ja, archiveren',
                                                        cancelText: 'Annuleren',
                                                        onOk() {
                                                            api.archiveOffer(item.id).then(() => {
                                                                api.getOffers().then(setOffers);
                                                            })
                                                        }
                                                    })
                                                }}
                                                className={"mar-r-1"}
                                            >
                                                Archiveer
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        )
                    }
                },
                {
                    key: 'image', 
                    title: '', 
                    width: '150px', 
                    responsive: ['md'],
                    render(item) {
                        return (
                            <CdnImage
                                src={item.image}
                                width={150}
                                height={150}
                                alt={item.title}
                            />
                        )
                    }
                },
                {key: 'title', title: 'Titel', dataIndex: 'title', responsive: ['md']},
                {key: 'stock', title: 'Voorraad', dataIndex: 'stock', responsive: ['md']},
                {
                    key: 'price', 
                    title: 'Prijs', 
                    responsive: ['md'],
                    render(item) {
                        return printPrice(item.price) + (item.unit ? ' per ' + item.unit : '')
                    }
                },
                {
                    key: 'start_at', 
                    title: 'Verkoopperiode',
                    responsive: ['md'],
                    render(item) {
                        return (
                            <>
                                van: {item.start_at ? dayjs(item.start_at).format(DATE_FORMAT) : '-'}<br/>
                                tot: {item.end_at ? dayjs(item.end_at).format(DATE_FORMAT) : '-'}
                            </>
                        )
                    }
                },
                {
                    key: 'actions', 
                    title: 'Acties', 
                    responsive: ['md'],
                    render(item) {
                        return (
                            <>
                                <Button onClick={() => {
                                    setOfferFormModalOpen(true)
                                    setEditingOffer(item)
                                }} size={"small"} className={"mar-r-1"}>
                                    Aanpassen
                                </Button>
                                <Button danger size={"small"} onClick={() => {
                                    Modal.confirm({
                                        title: 'Aanbod archiveren?',
                                        content: 'Dit aanbod wordt gearchiveerd en niet meer getoond op je profiel.',
                                        okText: 'Ja, archiveren',
                                        cancelText: 'Annuleren',
                                        onOk() {
                                            api.archiveOffer(item.id).then(() => {
                                                api.getOffers().then(setOffers);
                                            })
                                        }
                                    })
                                }} className={"mar-r-1"}>Archiveer</Button>
                            </>
                        )
                    }
                }
            ]}>

            </Table>
        </div>
    )
}